

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Info from '@/views/AiiTasks/Info.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import { zeroUnit } from '@/web-task/utils'
import LawsuitApi from '@/api/lawsuit'
import { updateViewer } from '@/utils/util'

let viewer: any = ''

@Component({
	components: {
		Info,
		ImageList,
	},
})
export default class selectLawyer extends Vue {
	private lawyerList: any = []
	private image: any = {}
	private currentPage: number = 1
	private total: number = 0
	private PAGE_SIZE = 10

	@Prop()
	private order!: any

	private get renderList() {
		let list: any = []
		this.lawyerList.forEach((lawyer: any, index: number) => {
			let mediaInfoList = []
			if (lawyer.formWear) {
				mediaInfoList.push({
					picId: '0',
					picName: '正装照',
					picUrl: lawyer.formWear,
				})
			}
			if (lawyer.identificationPhoto) {
				mediaInfoList.push({
					picId: '1',
					picName: '身份证照',
					picUrl: lawyer.identificationPhoto,
				})
			}
			list.push({
				title: `律师信息${index + 1}`,
				children: [
					{
						label: '姓名',
						value: lawyer.name,
					},
					{
						label: '性别',
						value: this.$store.state.setting.sexMap[lawyer.sex],
					},
					{
						label: '联系方式',
						value: lawyer.phone,
					},
					{
						label: '执业执照',
						value: lawyer.license,
					},
					{
						label: '律所名称',
						value: lawyer.lawOffice,
					},
					{
						label: '执业地区',
						value: lawyer.fullDesc,
					},
					{
						label: '擅长领域',
						value: lawyer.brief,
					},
					{
						label: '综合得分',
						value: zeroUnit(lawyer.score, '分') || '-',
					},
				],
				imageList: mediaInfoList,
			})
		})
		return list
	}

	@Watch('order', { immediate: true })
	private onOrderChange() {
		this.getLawyerList()
	}

	@Watch('currentPage')
	private onCurrentPageChange() {
		this.getLawyerList()
	}

	private getLawyerList() {
		let orderId = this.order.orderId
		if (!orderId) {
			return
		}
		LawsuitApi.getLawyerList({
			orderId: orderId,
			pageNum: this.currentPage,
			pageSize: this.PAGE_SIZE,
		}).then((res: any) => {
			this.lawyerList = res.data.retList
			this.total = res.data.count
			this.$nextTick(() => {
				viewer = updateViewer(viewer, '.lawyers-wrapper')
			})
		})
	}

	private onSelect(index: number) {
		let currentLawyer = this.lawyerList[index]
		let name = currentLawyer && currentLawyer.name
		this.$confirm({
			title: '提示',
			content: (
				<div>
					确认是否选择律师-<span style="color: #0064DC;">{name}</span>
					-为该案件的代理律师？
				</div>
			),
			onOk: () => {
				return LawsuitApi.selectLawyer(
					this.$route.params.orderId,
					currentLawyer.thirdId
				).then((res: any) => {
					this.$emit('getDetail')
				})
			},
		})
	}

	private beforeDestroy() {
		viewer && viewer.destroy()
		viewer = ''
	}
}
